import { useWrapRequest } from 'use-wrap-request';
import { Api } from '../../core/api';
import { injectTSDI } from '../../core/tsdi';
import { VendorUpdateSupportDto, ProductState } from '@api/WalletClient';

export function useVendorDetailsStore() {
    const { walletClient } = injectTSDI(Api);

    const vendor = useWrapRequest(
        async (vendorId: number) => {
            const result =
                await walletClient.supportApi.vendorSupportControllerGetDetails(
                    vendorId
                );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    const updateVendor = useWrapRequest(
        async (vendorId: number, data: VendorUpdateSupportDto) => {
            const result =
                await walletClient.supportApi.vendorSupportControllerUpdateVendor(
                    vendorId,
                    data
                );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    const updateVendorState = useWrapRequest(
        async (vendorId: number, state: ProductState) => {
            const result =
                await walletClient.supportApi.vendorSupportControllerUpdateVendorState(
                    vendorId,
                    { state }
                );
            return result.data;
        },
        {
            defaultData: null
        }
    );

    const handleUpdateVendor = async (
        vendorId: number,
        data: VendorUpdateSupportDto
    ) => {
        await updateVendor.request([vendorId, data]);
        // Refetch the vendor details after update
        await vendor.request([vendorId]);
    };

    const handleUpdateVendorState = async (
        vendorId: number,
        state: ProductState
    ) => {
        await updateVendorState.request([vendorId, state]);
        // Refetch the vendor details after state update
        await vendor.request([vendorId]);
    };

    return {
        vendor,
        updateVendor,
        updateVendorState,
        handleUpdateVendor,
        handleUpdateVendorState
    };
}
